module.exports = __webpack_public_path__ + "img/lv17.4a290d1c.png";